// CRM 2.0 Banking page (M10-F1, DC-73): opened from the "Banking" menu by the Banking
// and Finance teams. Tabs follow the role's Banking permissions (Users › Role permissions):
//   CF NOC   Banking › CF NOC › View      (Download: CF Excel / Undo sent; Upload: Upload CF / Undo)
//   Lenders  Banking › Lenders › View     (Edit adds / edits / switches off lenders)
// Super Admin (level 1) sees and does everything, as in the rest of CRM 2.0.
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Crm2LendersSection } from "../../Components/Crm2/Settings/Crm2Settings";
import CfNocList from "../../Components/Crm2/CfNoc/CfNocList";
import css from "./BankingPage.module.css";

function useBankingAccess() {
  const user = useSelector((state) => state.Auth.user);
  const isAdmin = user?.roleId?.level == 1;
  const banking = user?.roleId?.accessibleTabs?.Banking;
  const has = (...path) => {
    if (isAdmin) return true;
    let node = banking;
    if (!node?.isAccessible) return false;
    for (const key of path) {
      node = node?.[key];
      if (!node?.isAccessible) return false;
    }
    return true;
  };
  return {
    isAdmin,
    cfNocView: has("CF NOC", "View"),
    cfNocDownload: has("CF NOC", "Download"),
    cfNocUpload: has("CF NOC", "Upload"),
    lendersView: has("Lenders", "View") || has("Lenders", "Edit"),
    lendersEdit: has("Lenders", "Edit"),
  };
}

const BankingPage = () => {
  const access = useBankingAccess();
  const tabs = [access.cfNocView && "CF NOC", access.lendersView && "Lenders"].filter(Boolean);
  const [tab, setTab] = useState(tabs[0]);

  return (
    <div className={css.page}>
      <p className={css.title}>Banking</p>
      {tabs.length === 0 ? (
        <div className={css.empty}>You have no Banking actions. Ask your admin to give your role Banking › CF NOC or Banking › Lenders.</div>
      ) : (
        <>
          <div className={css.tabs} role="tablist">
            {tabs.map((t) => (
              <button key={t} type="button" role="tab" aria-selected={t === tab} className={`${css.tab} ${t === tab ? css.tabOn : ""}`} onClick={() => setTab(t)}>
                {t}
              </button>
            ))}
          </div>
          {tab === "CF NOC" && <CfNocList canDownload={access.cfNocDownload} canUpload={access.cfNocUpload} isAdmin={access.isAdmin} />}
          {tab === "Lenders" && <Crm2LendersSection canEdit={access.lendersEdit} />}
        </>
      )}
    </div>
  );
};

export default BankingPage;
